<style type="text/css" media="print">
  @page { size: portrait; }
</style>

<!-- Lista recomendacoes -->
<p class="text-center" ng-show="recommendations && !recommendations.length && !loading">
  <small>Nenhuma Recomendação...</small>
</p>

<span class="input-group-addon no-border no-background" ng-show="loading">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<uib-accordion close-others="true" class="list-recomendacoes" id="list-recommendation-history" ng-show="recommendations.length && !loading">
  <div infinite-scroll="getRecommendations()"
       infinite-scroll-parent="true"
       infinite-scroll-immediate-check="false">
    <uib-accordion-group
      class="panel-default panel-{{recommendation.status.color}} {{recommendation.status.color}} {{recommendation.emAndamento ? 'striped' : ''}} {{recommendation.emAndamentoAtrasada ? 'striped-danger' : ''}}"
      is-open="recommendation.open" ng-repeat="recommendation in recommendations">
      <uib-accordion-heading>
        <div ng-click="openRecommendationDetail($event, recommendation)">
          <i class="pull-right fa fa-2x" ng-hide="recommendation.loading"
             ng-class="{'fa-minus-circle': recommendation.open, 'fa-plus-circle': !recommendation.open}">
          </i>
          <span ng-show="recommendation.loading">
          <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
        </span>

          {{::recommendation.glebas | getTextItems}}

          <br>
          <small class="text-white">
            <i class="fa fa-calendar"></i>
            {{::recommendation.data_inicio | date:'dd/MM'}} à {{::recommendation.data_termino | date:'dd/MM'}}
          </small>
        </div>
        <div class="clearfix"></div>
      </uib-accordion-heading>

      <div ng-repeat="gleba in ::recommendation.allData.glebas">
        <div ng-if="!recommendationFilters.gleba || recommendationFilters.gleba.id == gleba.id">
          <p ng-if="recommendation.allData.situacao == 'rejeitado'" class="text-center">
            <strong>Recomendação rejeitada</strong>
            <br>
            {{::recommendation.allData.motivo_rejeicao}}
          </p>

          <p ng-if="recommendation.allData.situacao == 'aguardando_aprovacao'" class="text-center">
            <strong>Aguardando aprovação</strong>
          </p>
          <hr class="hr-sm">

          <p>
            <strong>Código: </strong>
            {{::recommendation.id}} <br>
            <strong>Previsto: </strong>
            {{::recommendation.allData.data_inicio | date:'dd/MM/yyyy'}}  até {{::recommendation.allData.data_termino | date:'dd/MM/yyyy'}}
            <br>
            <strong>Recomendante: </strong>
            {{::recommendation.allData.recomendante.nome_completo | capitalize}}
            <br>
            <strong>Responsável: </strong>
            {{::recommendation.allData.responsavel.nome_completo | capitalize}}
          </p>

          <strong>{{gleba.descricao}}</strong> ({{gleba.area_recomendada | number:1}}ha)

          <strong ng-show="gleba.aplicada && recommendation.status.descricao != 'aplicada'"> - Já aplicada</strong>
          <strong ng-show="!gleba.aplicada && gleba.percentual_aplicado > 0"> - Aplicado em {{gleba.percentual_aplicado | number:1}}%</strong>

          <dl>
            <dt ng-repeat-start="produto in ::recommendation.allData.produtos track by $index" class="text-light pull-left">
              {{::produto.produto.descricao}}
            </dt>
            <dd class="pull-right text-right dose-total">
              <strong>{{produto.qt_dose | formatDynamicDecimals}}</strong> <span class="text-light">{{::produto.unidade.abreviatura}}/ha</span><br>
              <small><span class="text-light">Total:</span> {{calculateTotalProduto(produto, gleba.area_recomendada, recommendation.allData.glebas.length > 1) | formatDynamicDecimals}}</small> {{::produto.unidade.abreviatura}}
            </dd>
            <div ng-repeat-end class="clearfix"></div>
          </dl>
        </div>
      </div>

      <a class="text-white" ng-if="canEditRecommendation(recommendation)"
         ng-click="concludeRecommendation(recommendation)">
        Encerrar recomendação
        <br>
      </a>

      <span ng-show="recommendation.waiting">
      <i class="pull-right fa fa-spinner fa-spin"></i>
    </span>

      <div class="text-right">
      <span class="btn" uib-tooltip="Imprimir" ng-print print-element-id="print-correcao-{{recommendation.id}}">
        <i class="fa fa-print" aria-hidden="true"></i>
      </span>
        <a class="text-white" ng-click="editRecommendation(recommendation.allData)" ng-if="$root.permissions.recomendacaoCorrecaoSolo.canManage">
          <u><i class="fa fa-cog" aria-hidden="true" ></i>Editar</u>
        </a>
      </div>

      <!-- Impressão -->
      <div id="print-correcao-{{recommendation.id}}" class="only-print">
        <div class="pendente-aprovacao-background" ng-if="recommendation.situacao === 'aguardando_aprovacao'">
          <svg width="100%" height="100%" style="transform:rotate(-45deg);" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400">
            <text x="25%" y="45%" style="fill: #cfcfcf73;">Pendente para aprovação</text>
          </svg>
        </div>
        <div class="title-recomendacoes">
          Recomendação de Correção de Solo #{{recommendation.id}}
        </div>
        <br>

        <ng-include src="'views/propriedade/print/recomendacao-correcao-solo-adubacao.html'"></ng-include>
      </div>
    </uib-accordion-group>
  </div>
  <div class="clearfix"></div>
</uib-accordion>
